import { CustomButton } from '@/components/global/buttons/CustomButton.jsx';
import CreateIcon from '@/assets/icons/create-icon.svg?react';
import PropTypes from 'prop-types';

export const AddSubsetButton = ({ onAdd, disabled = false }) => (
    <CustomButton
        type='button'
        color='secondary'
        variant='contained'
        label='resources.parameter.labels.addSubset'
        startIcon={<CreateIcon />}
        onClick={onAdd}
        disabled={disabled}
    />
);

AddSubsetButton.propTypes = {
    onAdd: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};
